import {ConflictType} from '@domain/conflicts/conflict-type';
import {Conflict, LockIconConfig} from '@vdw/angular-component-library';
import {Observable, Subject} from 'rxjs';

export function getLockIconConfig(name: string, conflictsObservable: Observable<Conflict[]>, rowActionsComplete?: Subject<void>): LockIconConfig {
  return {name, conflictsObservable, rowActionsComplete, conflictType: ConflictType};
}
